const $ = jQuery.noConflict();
import "slick-carousel";

const sliders = document.querySelectorAll(".component-slider");

const setSlideHeight = () => {
  jQuery(".component-slider").each(function () {
    if (jQuery(this).find(".gallery-slider__image-container").length) {
      // Caption width
      jQuery(".gallery-slider__image-container").each(function () {
        let imageWidth = jQuery(this).children("img").outerWidth();
        let caption = jQuery(this).next(".gallery-slider__caption");
        if (caption) {
          jQuery(this)
            .next(".gallery-slider__caption")
            .css("width", imageWidth);
        }
      });
      // Caption width
      const slideHeight = jQuery(
        ".gallery-slider__image-container:eq(0)",
        this
      ).outerHeight();
      jQuery(this).css("--slide-height", slideHeight + "px");
      jQuery(".gallery-slider__video-link", this).css(
        "height",
        slideHeight + "px"
      );
    } else {
      //  if (jQuery(window).height() > 901).
      const slideHeight = jQuery(this).find(".slick-list").outerHeight();
      jQuery(this).css("--slide-height", slideHeight + "px");
      jQuery(this)
        .find(".slick-slide .js-component-card")
        .css("height", slideHeight + "px");
    }
  });
};

// GLOBAL APP CONTROLLER
const controller = {
  init() {
    if (sliders.length) {
      sliders.forEach((currentSlider) => {
        if (!currentSlider.hasAttribute("data-slick")) {
          const parentWithSettings = currentSlider.closest("[data-slick]");

          if (parentWithSettings) {
            currentSlider.setAttribute(
              "data-slick",
              parentWithSettings.getAttribute("data-slick")
            );
          }
        }

        const args = JSON.parse(currentSlider.getAttribute("data-slick"));
        currentSlider.removeAttribute("data-slick");

        if (args.hasCustomPaging) {
          args.customPaging = function (slider, i) {
            return (
              ("0" + (i + 1)).slice(-2) +
              "/" +
              ("0" + slider.slideCount).slice(-2)
            );
          };
        }

        $(currentSlider).slick(args);
      });

      $(window).on("block-library-change resize", function () {
        $(".component-slider").slick("refresh");
      });
    }
    setSlideHeight();
  },
  loaded() {},
  resized() {
    setSlideHeight();
  },
  scrolled() {},
  keyDown() {},
  mouseUp() {},
};
export default controller;
